import { sumUsage, TIERED_PRODUCTS, type TieredPriceProductId } from "@project/common";

export const checkIsApproachingLimit = (usage: [number, number][] | number, product: TieredPriceProductId) => {
  const { freeTierAllowance, unitSize } = TIERED_PRODUCTS[product];
  const usageSum = typeof usage === "number" ? usage : sumUsage(usage);
  return usageSum > freeTierAllowance * unitSize * 0.6;
};
